import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/comments";

const commentApi = {
  getComments(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getReplyComments(params: any): Promise<any> {
    const url = `${path}/replies`;
    return api.get(url, params);
  },

  getCommentDetail(id: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url);
  },

  getSummaryComments(params: any): Promise<any> {
    const url = `${path}/summary`;
    return api.get(url, params);
  },

  postComment(dataForm: any): Promise<any> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putComment(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  updateApprovalStatusComment(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}/approval-status`;
    return api.put(url, dataForm);
  },

  deleteComment(id: any) {
    return api.delete(`${path}/${id}`);
  },
};

export default commentApi;
